import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import * as _ from 'lodash';
import { FormControl, FormGroup } from '@angular/forms';
interface ColorCodeItem {
  color: string;
  title: string;
  desc: string;
  activeIcon: string;
  inActiveIcon: string;
  selected: boolean;
}
@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  standalone: false,
})
export class FilterComponent extends BaseInjectorService implements OnInit {
  @Input() isHSEUser: boolean = false;
  segments: any;
  currentCheckedInSegment: any;
  isSelectedCurrentYear: boolean;
  isSelectedMyself: boolean;
  isSelectedOtherShieldUser: boolean;
  filter_site_list: any;
  all_sites_list: any;

  filterCount: number = 0;
  segmentNameList: any[];
  listsOfSegments: any;
  colorCode: ColorCodeItem[] = [
    {
      color: '#6A6A6A',
      title: 'Never',
      desc: '',
      activeIcon: 'assets/img/checkin/filters-png/factory_black.png',
      inActiveIcon: 'assets/img/checkin/filters-png/factory_black_inactive.png',
      selected: false,
    },
    {
      color: '#94C12E',
      title: '>6',
      desc: 'months',
      activeIcon: 'assets/img/checkin/filters-png/factory_red.png',
      inActiveIcon: 'assets/img/checkin/filters-png/factory_red_inactive.png',
      selected: false,
    },
    {
      color: '#FF6E00',
      title: '3-6',
      desc: 'months',
      activeIcon: 'assets/img/checkin/filters-png/factory_orange.png',
      inActiveIcon: 'assets/img/checkin/filters-png/factory_orange_inactive.png',
      selected: false,
    },
    {
      color: '#F00014',
      title: '<3',
      desc: 'months',
      activeIcon: 'assets/img/checkin/filters-png/factory_green.png',
      inActiveIcon: 'assets/img/checkin/filters-png/factory_green_inactive.png',
      selected: false,
    },
  ];
  isButtonDisabled: boolean;
  resetClick: boolean = false;
  sliderValue = {
    startRatingValue: 1,
    endRatingValue: 1,
  };

  form = new FormGroup({
    startRatingValue: new FormControl(1),
    endRatingValue: new FormControl(1),
  });
  sliderReady = false;
  segmentsList: any[] = [];
  constructor(
    private modalCtrl: ModalController,
    public appService: AppService,
    private changeDetection: ChangeDetectorRef
  ) {
    super();
  }

  async ngOnInit() {
    const savedFilters = await this.lhStorage.get('checkInFilterState');
    this.filterCount = 0;
    if (savedFilters) {
      this.updateFilterState(savedFilters);
    } else {
      this.sliderReady = true;
      this.isSelectedMyself = false;
      this.isSelectedOtherShieldUser = false;
    }
  }
  updateFilterState(savedFilters) {
    if (savedFilters.shieldVisit.length == 2) {
      this.isSelectedMyself = true;
      this.isSelectedOtherShieldUser = true;
      this.filterCount++;
    } else if (savedFilters.shieldVisit.length == 1 && savedFilters.shieldVisit[0] == 'myself') {
      this.isSelectedMyself = true;
      this.filterCount++;
    } else if (savedFilters.shieldVisit.length == 1 && savedFilters.shieldVisit[0] != 'myself') {
      this.isSelectedOtherShieldUser = true;
      this.filterCount++;
    }
    if (savedFilters.housekeepingRating.endRatingValue >= 1) {
      this.filterCount++;
    }
    this.colorCode = savedFilters.visitFrequency;
    this.form.patchValue({
      startRatingValue: savedFilters.housekeepingRating.startRatingValue,
      endRatingValue: savedFilters.housekeepingRating.endRatingValue,
    });
    setTimeout(() => {
      this.sliderReady = true;
    }, 100);

    console.log('savedFilters', savedFilters);
    const selectedColors = savedFilters.visitFrequency.filter((item: any) => item.selected).length;
    this.filterCount += selectedColors;
  }
  formatLabel(value: number): string {
    // Format the value as an integer
    return Math.round(value).toString();
  }

  onSliderChange(start, end) {
    (this.sliderValue.startRatingValue = start), (this.sliderValue.endRatingValue = end);
  }

  tourfilterSelected(tour) {
    this.colorCode.forEach((tourP: ColorCodeItem) => {
      if (tourP.title == tour.title) {
        tourP.selected = !tour.selected;
      }
    });
  }

  mySelf() {
    this.isSelectedMyself = !this.isSelectedMyself;
  }
  otherShieldUser() {
    this.isSelectedOtherShieldUser = !this.isSelectedOtherShieldUser;
  }

  async confirmSelection() {
    if (this.resetClick) {
      this.sliderReady = false;
      this.form.patchValue({
        startRatingValue: 1,
        endRatingValue: 0,
      });
      setTimeout(() => {
        this.sliderReady = true;
      }, 100);
      this.lhStorage.remove('checkInFilterState');
      this.modalController.dismiss(null);
      return;
    }
    let shieldVisited = [];
    if (this.isSelectedMyself && this.isSelectedOtherShieldUser) {
      shieldVisited = ['myself', 'others'];
    } else if (this.isSelectedMyself && !this.isSelectedOtherShieldUser) {
      shieldVisited = ['myself'];
    } else if (!this.isSelectedMyself && this.isSelectedOtherShieldUser) {
      shieldVisited = ['others'];
    } else {
      shieldVisited = [];
    }
    let filterState = {
      shieldVisit: shieldVisited,
      visitFrequency: this.colorCode,
      housekeepingRating: this.form.value,
      segmentsList: this.segmentsList
    };

    await this.lhStorage.set('checkInFilterState', filterState);
    console.log('filterState=', filterState);
    this.modalCtrl.dismiss(filterState);
  }

  async closebtn() {
    let checkInFilterState = await this.lhStorage.get('checkInFilterState');
    console.log('filterParams=', checkInFilterState);
    if (checkInFilterState === null || checkInFilterState === undefined) {
      this.modalCtrl.dismiss(null);
    } else {
      this.modalCtrl.dismiss(checkInFilterState);
    }
  }

  resetSelection() {
    this.resetClick = true;
    this.isSelectedMyself = false;
    this.isSelectedOtherShieldUser = false;
    this.sliderValue.startRatingValue = 1;
    this.sliderValue.endRatingValue = 0;
    this.colorCode.forEach((element: ColorCodeItem) => {
      element.selected = false;
    });
    this.sliderReady = false;
    this.form.patchValue({
      startRatingValue: 1,
      endRatingValue: 1,
    });
    setTimeout(() => {
      this.sliderReady = true;
    }, 100);
  }

  deSelect(segment) {
    this.segments = _.map(this.segments, (obj) => {
      if (obj.segment_category_name === segment.segment_category_name) {
        return { ...obj, selected: false };
      }
      return obj;
    });
  }

  unSelectSegment(segment) {
    this.segmentsList = _.map(this.segmentsList, (obj) => {
      if (obj.segment_category_name === segment.segment_category_name) {
        return { ...obj, selected: false };
      }
      return obj;
    });
  }

   selectSegment(segment) {
    this.segmentsList = _.map(this.segmentsList, (obj) => {
      if (obj.segment_category_name === segment.segment_category_name) {
        return { ...obj, selected: true };
      }
      return obj;
    });
  }
}
